export function FlavorTags({ tags }: { tags: string[] }) {
  if (!tags || tags.length === 0) return null;
  return (
    <p className="text-[11px] tracking-wide text-paper-600 italic">
      {tags.join(" · ")}
    </p>
  );
}
